import { FC, memo } from 'react';

import { IStepComponentProps } from 'components/ImportCsv/constants';

const ColumnMappingStep: FC<IStepComponentProps> = ({}) => {
  return (
    <div>ColumnMapping</div>
  );
};

export default memo(ColumnMappingStep);
